import axios from "axios";

import { toast } from "react-toastify";
import { Urls, mainUrl } from "../apiUrls/apiUrl";
export const DPR_API = {
  createResourceMapPower,
  get_Resource_role_type,
  get_Resource_role,
  get_Resource_Machinery,
  create_resource_machinery,
  get_material_activity,
  get_material_description,
  create_resource_material,
  get_resource_manpower,
  get_machinery,
  get_resource_material,
  get_resourcebysubId,
  get_resource_materialbysubId,
  get_resource_machinerybysubId,
  get_filter_resource_manpower,
  get_filter_resource_machinery,
  GetRiskAllocationDetails,
  SaveRiskDetails,
  GetProjectWorkPackage,
  getBilling,
  // GetSiteEngineer,
  GetUserByRoleID,
  UpdateProjectDetails,
  getSingleProject,
  GetDPRDetailsForApproval,
  UpdateDPRStatus,

  get_UOM,
  getWPO,
  getDprDetails,
  createDpr,
  getDprId,
  deleteAllRows,
  deleteRowDpr,
  GetIssueAllocationDetails,
  SaveIssueDetails,
  Create_Update_Observation,
  getObservation,
  Create_Update_Incident,
  Get_Incidents,
  Create_Update_JobSpecificTraining,
  Get_JobSpecificTraining,
  Create_Update_ToolboxTraining,
  Get_ToolboxTraining,
  Get_LO_LI_IDs,
  Get_ConsequenceManagement,
  Create_Update_ConsequenceManagement,
  Create_Update_WorkPermit,
  Get_WorkPermit,
  GetSOPSafetyDetails,
  getReportsData,
  getMytasks,
  MaxRow,
  updateDprDaliy,
  createScopeChart,
  getScopeChartDetails,
};

function MaxRow(Observations, Incident) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .get(
      mainUrl +
        `api/Safety/Get_Observation/Incident_MaxRow?Observations=${Observations}&Incident=${Incident}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function getReportsData(requestData, reportType) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Report/" + reportType, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function GetSOPSafetyDetails(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/ProjectArchival/GetSOPSafetyDetails", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Get_WorkPermit(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Get_WorkPermit", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Create_Update_WorkPermit(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Create_Update_WorkPermit", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Create_Update_ConsequenceManagement(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(
      mainUrl + "api/Safety/Create_Update_ConsequenceManagement",
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Get_ConsequenceManagement(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Get_ConsequenceManagement", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Get_LO_LI_IDs(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .get(mainUrl + "api/Safety/Get_LO_LI_IDs?LO_LI_ID=" + requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Get_ToolboxTraining(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Get_ToolboxTraining", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Create_Update_ToolboxTraining(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Create_Update_ToolboxTraining", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Get_JobSpecificTraining(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Get_JobSpecificTraining", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Create_Update_JobSpecificTraining(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(
      mainUrl + "api/Safety/Create_Update_JobSpecificTraining",
      requestData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Get_Incidents(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Get_Incidents", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Create_Update_Incident(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Create_Update_Incident", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
function getObservation(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Get_observations", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function Create_Update_Observation(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Safety/Create_Update_Observation", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function UpdateDPRStatus(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/DPR/UpdateDPRStatus", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function GetDPRDetailsForApproval(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/DPR/GetDPRDetailsForApproval", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function getSingleProject(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Projects/GetProjectAllocationDetails", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function UpdateProjectDetails(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Projects/UpdateProjectDetails", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
function GetUserByRoleID(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/User/GetUserByRoleID", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function getBilling() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .get(mainUrl + "api/Projects/GetBillingType", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function GetProjectWorkPackage(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/DPR/GetProjectWorkPackage", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized user ");
          window.location.href = "/login";
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function SaveRiskDetails(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Risk/SaveRiskDetails", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
function GetRiskAllocationDetails(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Risk/GetRiskAllocationDetails", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function get_resource_machinerybysubId(id) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  const requestData = {
    TaskID: id,
    user_id: state?.user?.user_id,
  };
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Resource/get_machinery", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function get_resource_materialbysubId(id) {
  return axios
    .get(Urls + "get_resource_materialbysubId/" + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
// function get_resourcebysubId(id) {
//   return axios
//     .get(Urls + "get_resourcebysubId/" + id)
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => {
//       if (error == "Unauthorized") {
//         return [];
//       }
//       if (error.response != undefined)
//         if (error.response.status === 401) {
//           toast.error("User nicht gefunden ");
//         } else if (error.response.status === 400) {
//           toast.error(error?.response?.data?.message);
//         } else if (error.response.status === 409) {
//           toast.error(error?.response?.data?.message);
//         } else if (error.response.status === 404) {
//           toast.error(error?.response?.data?.message);
//         } else if (error.response.status === 500) {
//           toast.error(error?.response?.data?.message);
//         }
//     });
// }

function get_resource_material(id) {
  return axios
    .get(Urls + "get_resource_material/" + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
function get_machinery(id) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  const requestData = {
    user_id: id,
  };
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Resource/get_machinery", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
// function get_resource_manpower(id) {
//     return axios
//         .get(Urls + "get_resource_manpower/"+id)
//         .then((response) => {
//             return response.data;
//         })
//         .catch((error) => {
//             if (error == "Unauthorized") {
//                 return [];
//             }
//             if (error.response != undefined)
//                 if (error.response.status === 401) {
//                     toast.error("User nicht gefunden ");
//                 } else if (error.response.status === 400) {
//                     toast.error(error?.response?.data?.message);
//                 } else if (error.response.status === 409) {
//                     toast.error(error?.response?.data?.message);
//                 } else if (error.response.status === 404) {
//                     toast.error(error?.response?.data?.message);
//                 } else if (error.response.status === 500) {
//                     toast.error(error?.response?.data?.message);
//                 }
//         });
// }
function create_resource_material(requestOptions) {
  return axios
    .post(Urls + "create_resource_material", requestOptions)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
function create_resource_machinery(requestOptions) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Resource/create_resource_machienry", requestOptions, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function get_material_description() {
  return axios
    .get(Urls + "get_material_description")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function get_material_activity() {
  return axios
    .get(Urls + "get_material_activity")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function get_Resource_Machinery() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .get(mainUrl + "api/Resource/get_Resource_Machinery", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function get_Resource_role() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .get(mainUrl + "api/Resource/get_Resource_role", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function get_Resource_role_type() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .get(mainUrl + "api/Resource/get_Resource_role_type", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function createResourceMapPower(requestOptions) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Resource/create_resource_manpower", requestOptions, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("Unauthorized Access");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}

function get_resource_manpower(id) {
  const requestData = {
    user_id: id,
  };
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .post(`${mainUrl}api/Resource/get_resource_manpower`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function get_resourcebysubId(id) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  const requestData = {
    TaskID: id,
    user_id: state?.user?.user_id,
  };
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .post(`${mainUrl}api/Resource/get_resource_manpower`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}

function get_filter_resource_manpower(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .post(`${mainUrl}api/Resource/get_resource_manpower`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}

function get_filter_resource_machinery(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .post(`${mainUrl}api/Resource/get_machinery`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function get_UOM() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .get(`${mainUrl}api/DPR/GetUOM`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function getWPO() {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .get(`${mainUrl}api/User/GetWPOwner`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function getDprDetails(wpId, taskId) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .get(
      `${mainUrl}api/DPR/GetDPRDetails?GUID=${wpId}&TaskID=${
        taskId ? taskId : 0
      }`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function createDpr(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .post(`${mainUrl}api/DPR/CreateDPR`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function updateDprDaliy(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .post(`${mainUrl}api/DPR/UpdateDPRDetailsOnDailyBasis`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function getScopeChartDetails(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .post(`${mainUrl}api/DPR/Get_ScopeChartDetails`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function createScopeChart(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .post(`${mainUrl}api/DPR/CreateScopeChart`, requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function getDprId(id) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .get(`${mainUrl}api/DPR/GetDPRID?IsConfirm=0&UserID=${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}

function deleteAllRows(id) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .delete(`${mainUrl}api/DPR/DeleteDPRID?DPRID=0&IsConfirm=0&UserID=${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}
function deleteRowDpr(dprid, userid) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;

  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }

  return axios
    .delete(
      `${mainUrl}api/DPR/DeleteDPRID?DPRID=${dprid}&IsConfirm=0&UserID=${userid}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("Error Response:", error.response);

      if (error == "Unauthorized") {
        return [];
      }

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.message || "An unexpected error occurred.";

        if (status === 401) {
          toast.error("Unauthorized Access");
        } else {
          toast.error(message);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    });
}

function GetIssueAllocationDetails(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Issue/GetIssueAllocationDetails", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
function SaveIssueDetails(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/Issue/SaveIssueDetails", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
function getMytasks(requestData) {
  const state = JSON.parse(localStorage.getItem("state"));
  const token = state?.token;
  if (!token) {
    toast.error("Authentication token not found. Please log in again.");
    return Promise.reject("Token missing");
  }
  return axios
    .post(mainUrl + "api/DPR/GetDPRDetailsForAssignedWPOwner", requestData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error == "Unauthorized") {
        return [];
      }
      if (error.response != undefined)
        if (error.response.status === 401) {
          toast.error("User nicht gefunden ");
        } else if (error.response.status === 400) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 409) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 404) {
          toast.error(error?.response?.data?.message);
        } else if (error.response.status === 500) {
          toast.error(error?.response?.data?.message);
        }
    });
}
